export function eventBus(Vue) {
    Vue.prototype.$eventBus = new Vue();
}





